// lbl.profile
export const profile = {
    tips_coins: 'TIP Coins',
    point_not_expire: 'Coins have no expiry date',
    edit: "Edit",
    birth_date: 'Date of Birth',
    contact_number: 'Contact Number',
    email: 'Email',
    password_no: 'Password No.',
    coin_history: 'Coins History',
    coin_tranfer: 'Coins Transfer',
    my_insurance: 'My Insurance',
    refresh: 'Refresh',
    carried: 'Carried',
    no_data: 'No Data',
    member_name: 'Member Name : ',
    policy_name: 'Policy Number : ',
    vehicle_number: 'vehicle registration number : ',
    effective_date : 'Effective Date : ',
    expire_date : 'Expired Date : ',
    insuenace_term: 'The coverage is in accordance with the policy conditions.',
    renewal_insurance: 'renewal the insurance',
    privacy_policies: 'Privacy Policies',
    term_cons: 'Terms & Conditions',
    contact_us: 'Contact Us',
    language: 'Language',
    en: 'EN',
    th: 'TH',
    delete_user: 'Delete User',
    sing_out: 'Sign Out',
    error: 'Error',
    call_center: 'Your insurance is not found Please contact Call Center',
    call_center_no: 'Call Center 1736',
    sing_out_confirm: 'Sign Out Confirmation',
    want_sing_out: 'Are you willing to sign out?',
    confirm: 'Confirm',
    edit_profile: 'Edit Profile',
    save: 'Save',
    confirm_edit: 'Profile Update Confirmation',
    confirm_edit2: 'Do you wish to update your profile?',
    save_success: 'Success',
    save_success2: 'Your Profile has been successfully updated',
    save_not_success: 'Not success',
    password_desc: 'Password must contain 8-20 characters including Captital letters, small letters, and numbers',
    point_not_enough: 'your point not enough to transfer',
    not_customer: 'You are not a customer of Dhipaya Insurance.',
    female: 'Female',
    male: 'Male',
    thai: 'Thai',
    foreign: 'Foreign',
    password: 'Password',
    pincode: 'PIN CODE'

};
